import React from "react";
import { AccompagnementCard } from "./AccompagnementCard";

// Remplacez ces chemins par vos vraies images (import local ou dossier public/)
import phytoImg from "../../assets/images/appImages/HYPERterapie.jpg";
import medecineImg from "../../assets/images/appImages/coran.jpg";
import hijamaImg from "../../assets/images/appImages/h.jpg";
import roqyaImg from "../../assets/images/appImages/roqua.jpg";

interface AccompagnementItem {
  id: string;
  image: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  linkText: string;
  linkTo: string;
}

const accompagnements: AccompagnementItem[] = [
  {
    id: "phyto",
    image: phytoImg,
    icon: "🌿",
    title: "Phytothérapie",
    description:
      "Une utilisation responsable des plantes, fondée sur leurs usages traditionnels, leur qualité, les précautions nécessaires et les besoins de la personne.",
    linkText: "Découvrir nos produits",
    linkTo: "/accompagnements#phyto",
  },
  {
    id: "medecine",
    image: medecineImg,
    icon: "📖",
    title: "Médecine prophétique",
    description:
      "Une approche inspirée des enseignements de la tradition prophétique, présentée avec pédagogie, discernement et références vérifiées.",
    linkText: "Découvrir notre approche",
    linkTo: "/accompagnements#medecine",
  },
  {
    id: "hijama",
    image: hijamaImg,
    icon: "💧",
    title: "Hijama",
    description:
      "Une pratique traditionnelle réalisée avec une attention particulière à l'écoute, à la préparation, à l'hygiène et à la sécurité.",
    linkText: "Découvrir la Hijama",
    linkTo: "/accompagnements#hijama",
  },
  {
    id: "roqya",
    image: roqyaImg,
    icon: "🤲",
    title: "Roqya",
    description:
      "Un accompagnement spirituel fondé sur la récitation du Coran et les invocations authentiques, dans le respect de la personne et sans discours alarmiste.",
    linkText: "Découvrir la Roqya",
    linkTo: "/accompagnements#roqya",
  },
];

const AccompagnementsSection: React.FC = () => {
  return (
    <section className="accompagnements-section">
      <div className="accompagnements-section-container">
        <p className="accompagnements-eyebrow mb-3">NOS ACCOMPAGNEMENTS</p>

        <h2 className="accompagnements-title mb-3">
          Des accompagnements pensés avec sérieux et responsabilité
        </h2>

        <p className="accompagnements-subtitle mb-5">
          Chaque personne et chaque situation sont différentes. Fouta Bio
          prend le temps d'écouter et d'expliquer avant de proposer un
          accompagnement.
        </p>

        <div className="accompagnements-grid">
          {accompagnements.map((item) => (
            <AccompagnementCard
              key={item.id}
              image={item.image}
              icon={item.icon}
              title={item.title}
              description={item.description}
              linkText={item.linkText}
              to={item.linkTo}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccompagnementsSection;